// Ambient floating peacock-feather particles for the background.
// Subtle, slow, low-opacity, non-interactive.

const FEATHERS = [
  { left: "6vw", top: "12vh", size: 90, delay: 0, duration: 32, rot: -12 },
  { left: "78vw", top: "18vh", size: 110, delay: 5, duration: 40, rot: 18 },
  { left: "20vw", top: "68vh", size: 80, delay: 10, duration: 36, rot: 6 },
  { left: "72vw", top: "76vh", size: 130, delay: 2, duration: 44, rot: -20 },
  { left: "48vw", top: "40vh", size: 60, delay: 8, duration: 30, rot: 0 },
];

function Feather({ size, rot }) {
  const id = "fd-" + Math.random().toString(36).slice(2, 6);
  return (
    <svg
      viewBox="0 0 80 120"
      width={size}
      height={(size / 80) * 120}
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${rot}deg)` }}
    >
      <defs>
        <linearGradient id={`${id}-g`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#5BAD7E" />
          <stop offset="55%" stopColor="#0FA3A3" />
          <stop offset="100%" stopColor="#2E5FAB" />
        </linearGradient>
      </defs>
      <path
        d="M40 6 C 18 26, 18 70, 34 96 C 48 86, 54 42, 40 6 Z"
        fill={`url(#${id}-g)`}
        opacity="0.7"
      />
      <ellipse cx="40" cy="30" rx="5" ry="8" fill="#C5A059" opacity="0.7" />
      <path
        d="M40 6 L40 96"
        stroke="#8C6B29"
        strokeWidth="0.5"
        opacity="0.35"
      />
    </svg>
  );
}

export default function FeatherDrift() {
  return (
    <div
      aria-hidden
      className="fixed inset-0 pointer-events-none z-[1] overflow-hidden"
      style={{ opacity: 0.09 }}
    >
      {FEATHERS.map((f, i) => (
        <div
          key={i}
          className="feather-drift absolute"
          style={{
            left: f.left,
            top: f.top,
            animationDelay: `-${f.delay}s`,
            animationDuration: `${f.duration}s`,
          }}
        >
          <Feather size={f.size} rot={f.rot} />
        </div>
      ))}
    </div>
  );
}
